import React from 'react';

export const SuspendedStatus: React.FC = () => (
  <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="150" height="40" rx="6" fill="#DC3545" />
    <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold">
      Suspended
    </text>
  </svg>
)